import { ContentDataBlockHeader } from '@amf/shared/components/content/Content';

interface HeaderProps {
  block: ContentDataBlockHeader;
}

export default function Header({ block }: HeaderProps) {
  if (block.data.level === 2) {
    return <h2>{block.data.text}</h2>;
  }

  if (block.data.level === 3) {
    return <h3>{block.data.text}</h3>;
  }

  if (block.data.level === 4) {
    return <h4>{block.data.text}</h4>;
  }

  return null;
}
